(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/play/assets/javascripts/views/wheel-row.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/play/assets/javascripts/views/wheel-row.js'); 
'use strict';

svs.eurojackpot.components.play.views.WheelRow = Marionette.View.extend({
  ui: {
    wheelRow: '.js-eurojackpot-wheel-row'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }],
  radioEvents: {
    'huxflux:numbers': 'huxfluxNumbers'
  },
  modelEvents: {
    'change:isEmpty': 'changeIsEmpty'
  },
  template: data => svs.eurojackpot.components.play.templates.wheel_row(data),
  templateContext() {
    const {
      numbersMaxValue,
      numbersExtraMaxValue
    } = this.model.get('rules');
    return {
      numbersMaxValue,
      numbersExtraMaxValue
    };
  },
  initialize() {
    svs.eurojackpot.logger.debug('svs.eurojackpot.components.play.views.WheelRow initialized');
  },
  onAttach() {
    this.boards = new svs.tur.EJBoards(this.getUI('wheelRow'), {
      maxValue: this.model.get('rules').numbersMaxValue,
      extraMaxValue: this.model.get('rules').numbersExtraMaxValue,
      responsiveWidth: true,
      disableHorizontalSwipe: true,
      onWheelChanged: wheel => {
        const isExtra = wheel.options.isStar;
        const value = wheel.value;
        let wheelIndex = wheel.wheelIndex;
        if (isExtra) wheelIndex -= 5;
        this.model.setNumber({
          number: value,
          index: wheelIndex,
          isExtra,
          manual: true
        });
      },
      onHuxfluxComplete: undefined
    });
    const {
      numbers,
      numbersExtra
    } = this.model.getNumberListArrays();
    this.boards.addBoard({
      values: numbers.concat(numbersExtra),
      animate: false
    });
    if (this.model.get('isEmpty')) {
      this.radio.trigger('huxflux:start', this.model);
    }
  },
  huxfluxNumbers(board, numbersToHuxflux) {
    if (board === this.model) {
      const numbers = numbersToHuxflux.map(numObj => numObj.number);
      this.boards.boards[0].huxflux(numbers);
    }
  },
  changeIsEmpty(model, isEmpty) {
    if (isEmpty) {
      const previous = this.model.collection.previous();
      if (previous) {
        previous.set('isActive', true);
      } else {
        this.radio.trigger('huxflux:start', this.model);
      }
    }
  }
});
 })(window);